import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChange, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { parseISO } from 'date-fns';

import { UserProfile, WorkTask, WorkTaskKeyType } from '../../models';
import { WorkTaskService } from './../../services';

@Component({
    selector: 'work-task',
    templateUrl: './work-task.component.html',
    styleUrls: ['./work-task.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, ReactiveFormsModule]
})
export class WorkTaskComponent implements OnChanges {

  @Output() save = new EventEmitter();
  @Output() cancel = new EventEmitter();
  @Input() keyType: WorkTaskKeyType;
  @Input() keyValue: number;
  @Input() model = {} as WorkTask;
  @Input() admins: UserProfile[];
  form: UntypedFormGroup;
  loading = false
  states = [
    { id: 5, name: 'Stan Harrison' }];

  constructor(
    readonly formBuilder: UntypedFormBuilder,
    readonly workTaskService: WorkTaskService) {

    this.createForm();
  }

  ngOnChanges({ model }: { model: SimpleChange }) {

    if (this.model !== undefined) {

      this.form.reset(
        {
          subject: this.model.subject,
          dueOn: this.getDateValue(this.model.dueOn),
          completedOn: this.getDateValue(this.model.completedOn),
          assignedTo: this.model.assignedTo,
          comments: this.model.comments
        }
      );
    }
  }

  getDateValue(date) {
    if (!date) {
      return undefined;
    }
    let dp = new DatePipe(navigator.language);
    let p = 'y-MM-dd';
    const dateObj = typeof date === 'string' ? parseISO(date) : date;
    return dp.transform(dateObj, p);
  }

  createForm() {
    this.form = this.formBuilder.group({
      subject: ['', [Validators.required, Validators.maxLength(1000)]],
      dueOn: ['', []],
      completedOn: ['', []],
      assignedTo: ['', []],
      comments: ['', [Validators.maxLength(4000)]]
    });
  }

  color(val) {
    return val ? '#555555' : '#999999';
  }

  submitWorkTask() {
    if (this.loading === true || this.form.invalid) {
      return;
    }

    this.loading = true;

    const task = Object.assign({}, this.form.value) as WorkTask;

    console.log('submitWorkTask...model: ', this.model);

    if (this.model !== undefined) {
      task.id = this.model.id;
    } else {
      task.id = 0;
    }

    task.workTaskKeyType = this.keyType
    task.workTaskKeyValue = this.keyValue;

    if (task.id > 0) {
      this.workTaskService.update(task).subscribe(() => {
        this.loading = false;
        this.save.emit()
      });
    } else {
      this.workTaskService.add(task).subscribe(() => {
        this.loading = false;
        this.save.emit()
      });
    }
  }

  delete() {
    if (confirm('Are you sure you want to delete the task?')) {
      this.workTaskService.delete(this.model.id).subscribe(() => this.save.emit());
    }
  }

}
